// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollToTop_container__2oMaK","icon":"ScrollToTop_icon__1B4fW","text":"ScrollToTop_text__3_Uvf"};